import React from "react";
import { Link } from "react-router-dom";
import CrudPage from "../components/CrudPage";
import { StatusBadge } from "../components/StatusBadge";
import { AutistiPage } from "./AutistiAccounts";
import { SupplierFleetCell, SupplierFleetEditor } from "../components/suppliers/SupplierFleet";

export function Clienti() {
  return <CrudPage
    title="Clienti" endpoint="/customers" testidPrefix="clienti"
    fields={[
      { key: "name", label: "Nome / Ragione sociale" },
      { key: "type", label: "Tipo", type: "select", options: [{value:"privato",label:"Privato"},{value:"azienda",label:"Azienda"},{value:"agenzia",label:"Agenzia"}] },
      { key: "phone", label: "Telefono" },
      { key: "email", label: "Email", type: "email" },
      { key: "address", label: "Indirizzo", fullWidth: true },
      { key: "vat", label: "Partita IVA" },
      { key: "fiscal_code", label: "Codice fiscale" },
      { key: "contact_person", label: "Referente" },
      { key: "notes", label: "Note", type: "textarea", fullWidth: true },
    ]}
    columns={[
      { key: "name", label: "Nome", render: (r) => <Link to={`/clienti/${r.id}`} className="text-amber-400 hover:text-amber-300 font-medium">{r.name}</Link> },
      { key: "type", label: "Tipo" },
      { key: "phone", label: "Telefono" },
      { key: "email", label: "Email" },
      { key: "vat", label: "P.IVA" },
    ]}
  />;
}

export function Fornitori() {
  const hasEmail = (v) => {
    if (!v) return false;
    const s = String(v).trim();
    return s.length > 0 && /\S+@\S+\.\S+/.test(s);
  };
  return <CrudPage
    title="Fornitori" endpoint="/suppliers" testidPrefix="fornitori"
    fields={[
      { key: "name", label: "Nome società" },
      { key: "contact_person", label: "Referente" },
      { key: "phone", label: "Telefono" },
      { key: "email", label: "Email", type: "email" },
      { key: "vat", label: "P.IVA" },
      { key: "type", label: "Tipologia" },
      { key: "notes", label: "Note", type: "textarea", fullWidth: true },
      { key: "_fleet", label: "Autisti e veicoli esterni", type: "custom", fullWidth: true,
        render: (row) => <div className="rounded-xl border border-amber-500/30 bg-[#0A0907] p-4"><SupplierFleetEditor key={row.id} supplier={row} /></div> },
    ]}
    columns={[
      {
        key: "name",
        label: "Nome",
        render: (r) => (
          <div className="flex items-center gap-2 flex-wrap">
            <span className="text-slate-200 font-medium">{r.name}</span>
            {!hasEmail(r.email) && (
              <span
                data-testid={`fornitori-no-email-${r.id}`}
                title="Email mancante — gli scambi non arriveranno via notifica email"
                className="inline-flex items-center gap-1 text-[9px] uppercase tracking-widest font-mono-num font-bold text-rose-300 bg-rose-500/10 border border-rose-500/50 rounded px-1.5 py-0.5"
              >
                ⚠ Email mancante
              </span>
            )}
          </div>
        ),
      },
      { key: "contact_person", label: "Referente" },
      { key: "phone", label: "Telefono" },
      {
        key: "email",
        label: "Email",
        render: (r) => (
          hasEmail(r.email)
            ? <span className="text-slate-300">{r.email}</span>
            : <span className="text-rose-400/90 italic">—</span>
        ),
      },
      { key: "type", label: "Tipologia" },
      { key: "drivers", label: "Autisti / Veicoli", render: (r) => <SupplierFleetCell key={r.id} supplier={r} /> },
    ]}
  />;
}

export function Autisti() {
  return <AutistiPage/>;
}

export function Flotta() {
  return <CrudPage
    title="Flotta" endpoint="/vehicles" testidPrefix="flotta"
    fields={[
      { key: "brand", label: "Marca" },
      { key: "model", label: "Modello" },
      { key: "plate", label: "Targa" },
      { key: "category", label: "Categoria", type: "select", options: ["Sedan","Van","SUV","Minibus","Executive","Altro"].map(v=>({value:v,label:v})) },
      { key: "seats", label: "Posti", type: "number" },
      { key: "luggage", label: "Bagagli", type: "number" },
      { key: "owner", label: "Proprietario" },
      { key: "registration_date", label: "Immatricolazione", type: "date" },
      { key: "insurance", label: "Assicurazione" },
      { key: "insurance_expiry", label: "Scadenza assicurazione", type: "date" },
      { key: "inspection", label: "Revisione" },
      { key: "inspection_expiry", label: "Scadenza revisione", type: "date" },
      { key: "road_tax_expiry", label: "Scadenza bollo", type: "date" },
      { key: "status", label: "Stato", type: "select", options: [
        {value:"disponibile",label:"Disponibile"},{value:"in_servizio",label:"In servizio"},
        {value:"manutenzione",label:"Manutenzione"},{value:"non_disponibile",label:"Non disponibile"}
      ], default: "disponibile" },
      { key: "notes", label: "Note", type: "textarea", fullWidth: true },
    ]}
    columns={[
      { key: "plate", label: "Targa" },
      { key: "brand", label: "Marca", render: (r) => `${r.brand} ${r.model}` },
      { key: "category", label: "Categoria" },
      { key: "seats", label: "Posti" },
      { key: "insurance_expiry", label: "Scad. Assic." },
      { key: "inspection_expiry", label: "Scad. Revis." },
      { key: "status", label: "Stato", render: (r) => <StatusBadge status={r.status}/> },
    ]}
  />;
}
